import React from "react";
import styles from "../../common/AlertCard.scss";
import { getLocalizedStrings } from "./Presentational/paperlessBillingPopupLocalisedstrings";
//import Toggle from "../../common/Toggle";
import  PaperlessBillingPopup from "../../common/PaperlessBillingPopup"; 
import  HoverPopUp from "../../common/hoverPopUp"; 
import PaperlessBillingToggle from "./Presentational/PaperlessBillingToggle"; 
import PaperlessBillingTurnonPopup  from "./Presentational/PaperlessBillingTurnonPopup"; 
import PaperlessBillingTurnoffPopup from "./Presentational/PaperlessBillingTurnoffPopup";
import ViewEditPaperlessBilling from "./Presentational/ViewEditPaperlessBilling";
import ReactHtmlParser from 'react-html-parser';


class PaperlessBilling extends React.Component {
    
  constructor(props) {
    super(props);
    this.strings = getLocalizedStrings("PbTurnOnPopup");
    this.state = {
      hoverModal: false,
      isOpen: false
          
    };
  
    this. warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
    this. imageMail_On=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg';
    this. imageMail_Off=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOff.svg';
    this. imagePhone_On=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOn.svg';
    this. imagePhone_Off=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOff.svg';
    this. imageText_On=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOn.svg';
    this. imageText_Off=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOff.svg';
    this.imageInfo=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Information.svg';
    let imageMailOn;
    let imageMailOff;
    
    let button;
    this.button= <button id="paperlessBillingView" className={styles.ViewEditButton} onClick={this.props.viewEditHandler}>View / Edit</button>;
  //this.imageMailOn=this.props.toggleChecked ? <img src={this.imageMail_On} />:<img src={this.imageMail_Off} />;
  }
  viewHoverPopUp=()=>{ 
  
    this.setState({ hoverModal: true });
  }
  handleClose=()=>{ 
    this.state.hoverModal ? this.setState({ hoverModal: false }) : null;
  }
  componentDidMount() {
    // Bind the event listener
    document.addEventListener("mousedown", this.handleClose);
    document.addEventListener('mousedown', this.handleClickOutside);
  }
  componentWillUnmount(){
    document.removeEventListener("mousedown", this.handleClose);
    document.removeEventListener('mousedown', this.handleClickOutside);
  } 
onHoverOverEvent =(e)=>{
  if(e.type === "mouseenter"){
    this.setState({infoPopUp:true});
  }
}
onHoverOutEvent = (e) =>{
  this.setState({infoPopUp:false});
}
toolTipKeyPress= (e) =>{
  if(e.key === "Enter"){
    this.setState({infoPopUp:!this.state.infoPopUp});}
}
render() {
   return (
    <div onMouseLeave={this.onHoverOutEvent}>
    {(this.state.infoPopUp) && <div> <PaperlessBillingPopup infoPopupTxt={ReactHtmlParser(this.props.staticContent.infoPopupTxt)} /></div>}
      {this.state.hoverModal && <HoverPopUp  preferenceData={this.props.preferenceData.email_id} 
                     checkOpen={this.state.hoverModal} on
                    handleClose={this.handleClose.bind(this)} />}
    <div>
      {this.props.reason ?
    
    <div className={styles.AlertCards} id='paperlessBillingInfoPopUp' >
    <div className={styles.AlertCardData} >
    <p className={styles.AlertCardTitle}  onMouseEnter={this.onHoverOverEvent} onClick={this.onHoverOverEvent}> {this.props.AlertName1}
    <span className={styles.InfoIcon}>{this.props.AlertName2}<img className={styles.iconAlign} src={this.imageInfo} alt="Info Icon"  /></span>
    </p>
 <p className={styles.AlertCardSubtitle} onMouseEnter={this.onHoverOutEvent}> {ReactHtmlParser(this.props.staticContent.subTxt)}</p>
 
 <div>
  <div className={styles.warningImg}> 
<img src={this.warningIcon} alt="Warning Icon" />
</div> 
<div className={styles.reason}>
 {this.strings.inEligibleReason}
 </div>
 </div>
 </div>
 </div>

 :
      
      <div className={styles.AlertCards} id='paperlessBillingInfoPopUp'>
            <div className={styles.MainContainer}>
              <div className={styles.LeftContainer}>
                <div className={styles.AlertCardData} >
                    <p className={styles.AlertCardTitle} onMouseEnter={this.onHoverOverEvent} onClick={this.onHoverOverEvent}> {this.props.AlertName1}
                    <span className={styles.InfoIcon}>{this.props.AlertName2}<img tabIndex={0} onKeyPress={this.toolTipKeyPress} className={styles.iconAlign} src={this.imageInfo} alt="Info Icon" /></span>
                    </p>
                    <p className={styles.AlertCardSubtitle} onMouseEnter={this.onHoverOutEvent} > {ReactHtmlParser(this.props.staticContent.subTxt)}</p>
                     <div className={styles.ButtonSection}> 
                        {(this.props.toggleChecked)?
                       <div><img src={this.imageMail_On} onClick={this.viewHoverPopUp.bind(this)} alt="Mail Image On" />
                       {this.button}</div>
                       
                             :
                        null
                        }  
                    </div>
                    {this.props.errorPbDeEnrollMsg ?
                    <div>
                      <div className={styles.warningImg}>
                        <img src={this.warningIcon} alt="Warning Icon" />
                      </div>
                      <div className={styles.reason}>
                      {this.strings.ErrMsg}
                      </div>
                    </div>
                    :
                     null
                    }
                </div>

              </div>
           
             <div className={styles.DividerLine} /> 

              <div className={styles.RightContainer}>
                  <div className={styles.SwitchAlign}>
                      <PaperlessBillingToggle isToggleOn={this.props.toggleChecked}
                      paperlessToggle={this.props.paperlessToggle} isDisabled={this.props.isDisabled}
                     />

                  </div>
             </div> 
             
            
          </div>
        </div>
      }
       
                          
      </div>
                      
      </div>
    );

  }
}
export default PaperlessBilling;
